import axios from 'axios'
import {URL_PROJECT} from "./conf";
import url from "./conf";
import qs from 'qs'
import StorageConst from "../utils/StorageConst"

/** 正常返回returnCode标识 */
const RETURNCODE_SUCCESS = "SUCCESS";
/** 异常返回returnCode标识 */
const RETURNCODE_FAIL = "FAIL";
/** ajax基础配置*/
const ajax = axios.create({
  baseURL: URL_PROJECT,
  withCredentials: true,
  //转换数据的方法
  transformRequest: [
    function (data) {
      return qs.stringify(data, {arrayFormate: 'indices',allowDots: true});
    }
  ],
  //设置请求头
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

ajax.interceptors.request.use(
  config => {
    if (sessionStorage.getItem(StorageConst.COOKIE_TOKEN)) {
      config.headers.token = sessionStorage.getItem(StorageConst.COOKIE_TOKEN);
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  });

/**
 * post访问
 * @param url
 * @param data 参数
 * @param success 处理成功获取业务数据
 * @param fail
 * @param isLoadingExplicit 是否加载缓冲
 * @param errorHandler error处理
 */
export function post(url, data, success, fail,
                     isLoadingExplicit, errorHandler = this.$toast) {
  const that = this;
  //显示缓冲
  if (isLoadingExplicit) {
    that.$loading.show();
  }
  ajax.post(url, data)
    .then(function (response) {
      //关闭缓冲
      if (isLoadingExplicit) {
        that.$loading.hide();
      }
      // 业务返回数据处理
      if (RETURNCODE_SUCCESS === response.data.returnCode) {
        success(response.data);
      } else if (RETURNCODE_FAIL === response.data.returnCode) {
        failDefault.bind(that)(response.data, errorHandler);
        fail(response.data);
      }
    })
    .catch(function (error) {
      //关闭缓冲
      if (isLoadingExplicit) {
        that.$loading.hide();
      }
      // 网络故障
      networkFault(errorHandler);
    });
}
/**
 * post 下载
 * @param url
 * @param data 参数
 * @param success 处理成功获取业务数据
 * @param isLoadingExplicit 是否加载缓冲
 * @param errorHandler error处理
 */
export function postDownload(url, data, success,
                             isLoadingExplicit, errorHandler = this.$toast) {
  const that = this;
  //显示缓冲
  if (isLoadingExplicit) {
    that.$loading.show();
  }
  ajax.post(url, data,{
    responseType: 'blob' //指定返回数据的格式为blob
  })
    .then(function (response) {
      //关闭缓冲
      if (isLoadingExplicit) {
        that.$loading.hide();
      }
      success(response);
    })
    .catch(function (error) {
      //关闭缓冲
      if (isLoadingExplicit) {
        that.$loading.hide();
      }
      // 网络故障
      networkFault(errorHandler);
    });
}
/**
 * 调用CSRF token后访问POST
 * @param url
 * @param data
 * @param success
 * @param fail
 * @param isLoadingExplicit
 * @param errorHandler
 */
export function tokenPost(url, data, success, fail,
                          isLoadingExplicit, errorHandler) {
  var that = this;
  post.bind(this)(
    url.TOKEN,
    {},
    function (){
      post.bind(that)(url,data,success,fail,isLoadingExplicit,errorHandler)
    },
    fail,
    isLoadingExplicit,
    errorHandler
  );
}
/**
 * 处理返回"用户未登录"
 *
 * @returns 校验结果
 * @param errorCode 错误码
 */
function verifyLogin(errorCode) {
  const that = this;
  if ("NOT_LOGIN" == errorCode) {
    that.$alert("用户未登录，请重新登录！", function (clickConfirm) {
      that.$router.push({path:'/'}).catch(data => {  })
    }, false);
    return false;
  } else {
    return true;
  }
}

/**
 * 网络故障
 * @param errorHandler
 *  error处理
 */
function networkFault(errorHandler) {
  errorHandler("网络故障，请稍后再试！");
}

/**
 * 处理返回业务数据"FAIL"
 *
 * @param data
 *            JSON数据
 * @param errorHandler error处理
 */
function failDefault(data, errorHandler) {
  if (verifyLogin.bind(this)(data.errorCode)) {
    errorHandler(data.errorCodeDesc);
  }
}
/**
 * AJAX-登录
 * @param institutionId
 * @param userName
 * @param password
 * @param verifyCode
 * @param moduleType
 * @param success
 * @param fail
 * @param isLoadingExplicit
 * @param errorHandler error处理（可选）
 */
export function login(institutionId,moduleType, userName, password, verifyCode, success, fail,
                      isLoadingExplicit, errorHandler) {
  post.bind(this)(
    url.LOGIN,
    {
      institutionId: institutionId,
      moduleType: moduleType,
      username: userName,
      password: password,
      validateCode: verifyCode
    },
    success,
    fail,
    isLoadingExplicit,
    errorHandler
  );
}
/**
 * AJAX-退出
 */
export function logout(success, fail, isLoadingExplicit, errorHandler) {
  post.bind(this)(
    url.LOGOUT,
    {},
    success,
    fail,
    isLoadingExplicit,
    errorHandler
  )
}

/**
 * AJAX-统一验证接口
 */
export function valid(token,moduleType,success, fail, isLoadingExplicit, errorHandler) {
  post.bind(this)(
    url.VALID,
    {
      token: token,
      moduleType: moduleType,
    },
    success,
    fail,
    isLoadingExplicit,
    errorHandler
  )
}
/**
 * AJAX-修改密码
 */
export function modifyPassword(originPassword,password,success, fail, isLoadingExplicit, errorHandler) {
  post.bind(this)(
    url.MODIFY_PASSWORD,
    {
      originPassword: originPassword,
      password: password,
    },
    success,
    fail,
    isLoadingExplicit,
    errorHandler
  )
}



// WEBPACK FOOTER //
// ./src/assets/ajax/ajax.js